import React from 'react';
import { Card } from '../../components/ui/card';
import { Button } from '../../components/ui/button';
import { toast } from '../../hooks/use-toast';

const NoShowReportSection = ({ ride, status }) => {
  if (status !== 'accepted' || !ride) return null;

  const handleReportNoShow = async () => {
    if (window.confirm('Are you sure the driver is a no-show? This will penalize the driver and find you another one.')) {
      try {
        const api = (await import('../../utils/api')).default;
        await api.post(`/rides/${ride.id}/report-noshow`);
        toast({
          title: 'No-Show Reported',
          description: 'Driver penalized. Finding another driver for you...',
        });
        setTimeout(() => window.location.reload(), 2000);
      } catch (error) {
        toast({
          title: 'Error',
          description: error.response?.data?.detail || 'Failed to report no-show',
          variant: 'destructive',
        });
      }
    }
  };

  return (
    <Card className="p-4 bg-red-50 border-red-200">
      <p className="text-sm text-red-800 mb-3">
        Driver has not arrived yet? If the driver is taking too long or not responding, you can report a no-show.
      </p>
      <Button
        variant="outline"
        className="w-full text-red-600 border-red-300 hover:bg-red-100"
        onClick={handleReportNoShow}
      >
        Report Driver No-Show
      </Button>
    </Card>
  );
};

export default NoShowReportSection;
